import { createSelector } from 'reselect';

export const getIsAuthenticated = state => state.auth.isAuthenticated;

export const getHasError = state => state.auth.hasError;

export const getRequires2Fa = state => state.auth.requires2Fa;

export const getLoginDestination = state => state.auth.loginDestination;

export const getUsers = state => state.entities.users;

export const getAuthUserId = state => state.auth.userId;

export const getAuthUserAuthorities = state => state.auth.authorities;

export const getIsAuthenticating = state => state.auth.isLoading;

export const get2FaQrCodeUrl = state => state.auth.qrCodeUrl2Fa;

export const get2FaSecret = state => state.auth.secret2Fa;

export const getIs2FaSetupRequired = state => state.auth.is2FaSetupRequired;

export const getAccessToken = state => state.auth.accessToken;

export const getAuthUser = createSelector([getUsers, getAuthUserId], (users, id) => (users[id] ? users[id] : null));

export const getIsAdmin = createSelector(
  [getAuthUserAuthorities],
  authorities =>
    authorities.includes(`ROLE_${process.env.REACT_APP_ROLE_SUPERADMIN}`) ||
    authorities.includes(`ROLE_${process.env.REACT_APP_ROLE_ADMIN}`),
);

export const getForgotPasswordHasError = state => state.auth.forgotPassword.hasError;
export const getForgotPasswordIsLoading = state => state.auth.forgotPassword.isLoading;
export const getForgotPasswordIsSuccess = state => state.auth.forgotPassword.isSuccess;

export const getChangePasswordHasError = state => state.auth.changePassword.hasError;
export const getChangePasswordIsLoading = state => state.auth.changePassword.isLoading;
export const getChangePasswordIsSuccess = state => state.auth.changePassword.isSuccess;

export const getResetPasswordHasError = state => state.auth.resetPassword.hasError;
export const getResetPasswordIsLoading = state => state.auth.resetPassword.isLoading;
export const getResetPasswordIsSuccess = state => state.auth.resetPassword.isSuccess;

export const getVerifyTokenHasError = state => state.auth.resetPassword.hasVerifyError;
export const getVerifyTokenIsLoading = state => state.auth.resetPassword.isVerifyLoading;
export const getVerifyTokenIsSuccess = state => state.auth.resetPassword.isVerifySuccess;

export const getResetPasswordVerifyAuthCodeError = state => state.auth.resetPassword.hasVerifyAuthCodeError;
export const getResetPasswordIsVerifyAuthCodeLoading = state => state.auth.resetPassword.isVerifyAuthCodeLoading;
export const getResetPasswordIsVerifyAuthCodeSuccess = state => state.auth.resetPassword.isVerifyAuthCodeSuccess;

export const getEnable2FaHasError = state => state.auth.enable2Fa.hasError;
export const getEnable2FaIsLoading = state => state.auth.enable2Fa.isLoading;
